import { HOME_PROPERTY_TYPES } from 'components/Pages/HotelSearchPage/SearchVerticalTabs.config'
import { HOLIDAY_TYPE_HOMES_AND_VILLAS, HOLIDAY_TYPE_VACATION_RENTAL } from 'constants/offerList'
import { isBedbankUniqueStaysOffer, isFlashHotelOffer, isVillaOffer } from 'lib/offer/offerTypes'

interface Params {
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | App.VillaOffer | App.VillaOfferSummary
  filters?: App.OfferListFilters
  isEntireHome?: boolean
}

const HIDEABLE_ADULT_COUNTS = new Set([1, 2])

function getTotalAdults(filters?: App.OfferListFilters): number {
  return filters?.rooms?.reduce((sum, room) => sum + room.adults, 0) ?? 0
}

export function isAnytimeSearch(filters?: App.OfferListFilters): boolean {
  return !filters?.checkIn && !filters?.checkOut && !filters?.flexibleNights
}

const HOME_PROPERTY_TYPE_SET = new Set<string>(HOME_PROPERTY_TYPES)
const UNIQUE_STAYS_PROPERTY_TYPE = 'UNIQUE_STAYS'
const HOMES_SCOPED_HOLIDAY_TYPES = new Set<string>([HOLIDAY_TYPE_HOMES_AND_VILLAS, HOLIDAY_TYPE_VACATION_RENTAL])

export function shouldHideCroCompactSearchTileRoomBreakdown({
  hideFromView,
  offer,
}: {
  hideFromView: boolean
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | App.VillaOffer | App.VillaOfferSummary
  filters?: App.OfferListFilters
}): boolean {
  if (!hideFromView) return false
  if (isVillaOffer(offer) || isBedbankUniqueStaysOffer(offer)) return false
  return true
}

export function isHomesPropertyTypeFilter(filters?: App.OfferListFilters): boolean {
  return filters?.propertyTypes?.some(propertyType =>
    HOME_PROPERTY_TYPE_SET.has(propertyType) || propertyType === UNIQUE_STAYS_PROPERTY_TYPE,
  ) ?? false
}

export function isHomesSearchFilter(filters?: App.OfferListFilters): boolean {
  return isHomesPropertyTypeFilter(filters) ||
    (filters?.holidayTypesScoped?.some(holidayType => HOMES_SCOPED_HOLIDAY_TYPES.has(holidayType)) ?? false)
}

export function shouldHideSearchTileRoomRecommendation({
  filters,
  isCroCompact,
}: {
  filters?: App.OfferListFilters
  isCroCompact: boolean
}): boolean {
  return isCroCompact && isHomesSearchFilter(filters)
}

export function shouldHideSearchTileRoomBreakdown({ offer, filters, isEntireHome }: Params): boolean {
  if (isEntireHome) {
    return false
  }

  const totalAdults = getTotalAdults(filters)
  const isOneOrTwoAdultsSearch = HIDEABLE_ADULT_COUNTS.has(totalAdults)

  if (!isOneOrTwoAdultsSearch) {
    return false
  }

  if (isAnytimeSearch(filters)) {
    return true
  }

  return isFlashHotelOffer(offer)
}
